// extracted by mini-css-extract-plugin
export default {"post":"Post_post__vq3Nd","header":"Post_header__l7B6+","info":"Post_info__223nG","body":"Post_body__I3Twf","buttons":"Post_buttons__lqZEs"};